import { takeUntil } from 'rxjs/operators';
import { UnsubscribeOnDestroy } from 'src/app/_helpers/unsubscribe-on-destroy';
import { Component, Inject, LOCALE_ID, ViewChild } from '@angular/core';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Destinatario } from 'src/app/model/notificaresumen';
import { Envios } from 'src/app/model/notificadetalles';
import { NotificationService } from 'src/app/_services/notification.service';
import { ServicioGeneral } from 'src/app/_services/servicio-general.service';
import { DestinatarioDto } from '../destinatario_model';
import { formatDate } from '@angular/common';
import { NotificationI18nService } from '../../core/util/notification-i18n.service';

@Component({
  selector: 'app-notificaciones-aceptadas-usuario',
  templateUrl: './notificaciones-aceptadas-usuario.component.html',
  styleUrls: ['./notificaciones-aceptadas-usuario.component.scss']
})
export class NotificacionesAceptadasUsuarioComponent  extends UnsubscribeOnDestroy{

  notificaciones:Destinatario[]=[];
  notificacionesDto:DestinatarioDto[] = [];
  notificacionActivada:Envios;
  displayedColumns: string[] = ["Identificador", "Fecha disposición", "Entidad", "Estado"];
  dataSource = new MatTableDataSource<DestinatarioDto>();
  loading:boolean=false;
  display:string='none';
  diasCaducidad: string = localStorage.getItem('notificacionesAceptadasMaxDays');
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  get totalNotificaciones(): number { return this.dataSource?.data?.length || 0; }
  get notificacionesMostradas(): number { return this.dataSource?.filteredData?.length ?? this.totalNotificaciones; }

  constructor(
    private notificationI18n: NotificationI18nService,
    private _servicioGeneral: ServicioGeneral,
    @Inject(LOCALE_ID) public locale: string,
    ){
    super();
  }

  ngOnInit(): void {
    this.misNotificaciones();
  }

  misNotificaciones():void{
    this._servicioGeneral.postNotificaNotificaciones({ "estado":"ACEPTADA/RECHAZADA/RECHAZADA AUTOMATICAMENTE", "tipoEnvio": 2 })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
      next:(response) => {
        
        if(response.respuesta.code=="200"){
          this.notificaciones.concat(response.envios.titular??[]).concat(response.envios.destinatario??[]).forEach(response=> this.notificacionesDto.push({
            "Id":response.envio,
            "Identificador": response.identificador,
            "Fecha disposición":  new Date(this.formatoFecha(response.fecha_disposicion)),
            "Entidad": response.organismo_emisor,
            "Destinatario": response,
            "Estado": response.estado
          }))

          this.dataSource = new MatTableDataSource(this.notificacionesDto);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
        }
        else{
          this.notificationI18n.infoDynamic(response.respuesta, 4000);
        }
      },
      error:(err) => {
        this.notificationI18n.error('NOTIFICATION.MESSAGE.NO_SE_PUDIERON_CARGAR_LAS_COMUNICACIONES');
      },
    })
  }

  notificacionAcept(notificacion: Destinatario){
    
    this._servicioGeneral.getNotificaNotificaciones(notificacion.envio)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
      next:(response) => {
        if(response.respuesta.code=="200"){
          
          this.notificacionActivada=response.envios;
          this.display='block';
        }
        else{
          this.notificationI18n.infoDynamic(response.respuesta, 4000);
        }
      },
      error:(err) => {
        this.notificationI18n.error('NOTIFICATION.MESSAGE.NO_SE_PUDO_CARGAR_LA_COMUNICACION');
      },
    })
  }
  close(event:string) {
    this.display=event;
    this.notificacionActivada=null;
  }

  formatoFecha(date) {
    if(date){
      let month = date[1] ? (date[1]<10)?'0'+date[1]:date[1] : '';
      let day   = date[2] ? (date[2]<10)?'0'+date[2]:date[2] : '';
      let year  = date[0];
      let hour  = (date[3]<10)?'0'+date[3]:date[3];
      let min   = (date[4]<10)?'0'+date[4]:date[4];
      let seg   = date[5] ? (date[5]<10)?'0'+date[5]:date[5] : '00';
      
      return [ year, month, day].join('-').concat('T'+[hour, min, seg].join(':') + '.000Z');
    }
    return '';
  }


  formatDate(date:Date):String{
    return formatDate(date, 'dd-MM-yyyy HH:mm', this.locale, 'GMT');
  }

}
